import AreaChart from 'components/Charts/AreaChart';
import HorizontalBarChart from 'components/Charts/HorizontalBarChart';
import VerticalBarChart from 'components/Charts/VerticalBarChart';
import { useState } from 'react';
import Drawer from 'react-modern-drawer';

export default function ProjectAnalysis(projectDetails: any) {

    const EmailStatementClose = () => { projectDetails.ProjectAnalysisClose(); }

    console.log(projectDetails?.projectDetails)
    const dsps = [
        {
            name: "Spotify",
            image: "https://upload.wikimedia.org/wikipedia/commons/1/19/Spotify_logo_without_text.svg",
            totalGross: 9092626.87
        },
        {
            name: "Apple Music",
            image: "https://upload.wikimedia.org/wikipedia/commons/5/5f/Apple_Music_icon.svg",
            totalGross: 3015292.54
        },
        {
            name: "YouTube Music",
            image: "https://cdn.simpleicons.org/youtube",
            totalGross: 2269157.72
        },
        {
            name: "Amazon Music",
            image: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/92/Amazon_Music_logo.svg/120px-Amazon_Music_logo.svg.png?_=20211224163912",
            totalGross: 1851200.55
        },
        {
            name: "Deezer",
            image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQJpTpXbe6Dqy0BRsrcom3vb0fOaCUpXwEw7w&s",
            totalGross: 950340.21
        },
        {
            name: "Apple Music",
            image: "https://upload.wikimedia.org/wikipedia/commons/5/5f/Apple_Music_icon.svg",
            totalGross: 1578900.34
        },
        {
            name: "Deezer",
            image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQJpTpXbe6Dqy0BRsrcom3vb0fOaCUpXwEw7w&s",
            totalGross: 950340.21
        },
        {
            name: "Apple Music",
            image: "https://upload.wikimedia.org/wikipedia/commons/5/5f/Apple_Music_icon.svg",
            totalGross: 1578900.34
        }
    ];

    const yearRevenue = {
        options: {
            layout: { padding: { top: 0 } },
            plugins: {
                elements: {
                    bar: { borderWidth: 0 }
                }
            },
            interaction: { mode: 'index', intersect: false },
            scales: {
                x: {
                    title: {
                        display: true,
                        text: 'Period',
                        font: { size: 14, weight: 'bold' }
                    }
                },
                y: {
                    title: {
                        display: true,
                        text: 'Value',
                        font: { size: 14, weight: 'bold' }
                    }
                }
            },
            tension: 0.4
        },

        data: {
            labels: [
                202301, 202302, 202303, 202304, 202305, 202306,
                202307, 202308, 202309, 202310, 202311, 202312
            ],

            datasets: [
                {
                    label: "Spotify",
                    data: [1200, 1350, 1500, 1400, 1600, 2300, 1800, 1900, 1100, 2100, 2200, 1200],
                    borderColor: "#1DB954",
                    backgroundColor: "#1DB954",
                    yAxisID: "y",
                    fill: false,
                    cubicInterpolationMode: "monotone",
                    tension: 0.4
                },
                {
                    label: "Apple Music",
                    data: [900, 950, 2300, 1100, 1050, 1150, 1200, 2300, 1300, 1400, 1450, 1500],
                    borderColor: "#c7737c",
                    backgroundColor: "#c7737c",
                    yAxisID: "y",
                    fill: false,
                    cubicInterpolationMode: "monotone",
                    tension: 0.4
                },
                {
                    label: "YouTube",
                    data: [500, 600, 650, 1700, 750, 600, 420, 2000, 900, 950, 1000, 300],
                    borderColor: "#FF0000",
                    backgroundColor: "#FF0000",
                    yAxisID: "y",
                    fill: false,
                    cubicInterpolationMode: "monotone",
                    tension: 0.4
                },
                {
                    label: "Amazon Music",
                    data: [300, 350, 1400, 420, 150, 470, 2300, 1520, 550, 1700, 600, 750],
                    borderColor: "#FF9900",
                    backgroundColor: "#FF9900",
                    yAxisID: "y",
                    fill: false,
                    cubicInterpolationMode: "monotone",
                    tension: 0.4
                }
            ]
        }
    };

    const artistRevenue = {
        type: 'bar',

        options: {
            indexAxis: '', responsive: true,
        },

        data: {
            labels: [
                "ODESZA",
                "Thundercat",
                "Bonobo",
                "Black Country, New Road",
                "BICEP",
                "The Heavy",
                "The Cinematic Orchestra",
                "Big Wild",
                "Maribou State",
                "Hiatus Kaiyote"
            ],

            datasets: [
                {
                    label: "Total Gross",
                    data: [
                        4200000, 2600000, 2400000, 1800000, 1750000,
                        1700000, 1500000, 1100000, 1000000, 900000
                    ],
                    backgroundColor: "#1e793c",
                }
            ]
        }
    };

    const imprintRevenue = {
        type: 'bar',

        data: {
            labels: [
                "ODESZA",
                "Thundercat",
                "Bonobo",
                "Black Country, New Road",
                "BICEP",
                "The Heavy",
                "The Cinematic Orchestra",
                "Big Wild",
                "Maribou State",
                "Hiatus Kaiyote"
            ],

            datasets: [
                {
                    label: "Total Gross",
                    data: [
                        4200000, 2600000, 2400000, 1800000, 1750000,
                        1700000, 1500000, 1100000, 1000000, 900000
                    ],
                    backgroundColor: "#1e793c",
                }
            ]
        }
    };

    const [dspPageSize, SetDspPageSize] = useState(10);    
    const [AssetPageSize, SetAssetPageSize] = useState(10);
    const [FormatPageSize, SetFormatPageSize] = useState(10);
    const [ArtistPageSize, SetArtistPageSize] = useState(10);
    const [ImprintPageSize, SetImprintPageSize] = useState(10);
    const [TerritoryPageSize, SetTerritoryPageSize] = useState(10);

    return (
        <>


            <Drawer open={projectDetails?.openProjectAnalysis}
                onClose={EmailStatementClose}
                direction='right'
                className='react-drawer-left full-height-vh allowHscroll allowVscroll' style={{ width: "100%", height: "100%" }}>

                <div className='box noBorderRadius noBorder ws-12 box pull-right allowHscroll allowVscroll'>
                    <div className="box-header  noBorderRadius bg-blue pLarge"> Project Analysis </div>


                    <div className="ws-12 landing pLarge">

                        <div className='ws-12'>

                            <div className='w-32 box pm ms height100'>
                                <h3>Project Code</h3>
                                <p>M00004_ALL_</p>
                            </div>

                            <div className='w-32 box pm ms height100'>
                                <h3>Project Summary</h3>
                                <p>  Contract Num: 10 | Song: 5 |  Track: 5 | Release: 5 |  Track: 5</p>
                            </div>

                            <div className='w-34 box pm ms height100'>
                                <h3>Income Summary</h3>
                                <p>$2,198.64</p>
                                <p>Jan 1, 2024 — Mar 31, 2024</p>
                            </div>

                            <div className='ws-6 box pm hide'>
                                <h1 className="capitalize mb pull-left ws-12 ptl"> {projectDetails?.projectDetails?.projectCode} </h1>
                                <h3 className="capitalize mb pull-left ws-12  ptl"> {projectDetails?.projectDetails?.projectName} </h3>
                            </div>

                        </div>

                        <div className='w-100 box pm mt'>
                            <div className='ws-12'>


                                <select style={{ border: "none" }}>
                                    <option>Performance</option>
                                    <option>Royalty</option>
                                </select>

                                <button className='icon-btn info fill width120 pull-right height35'>Chart</button>
                                <button className='icon-btn info width120 pull-right height35'>Data Table</button>
                            </div>

                            <div className='ws-12 mtl'>
                                <input type="search" placeholder="Search DSP / Track, Release" className='ws-4 height35 pull-left' />

                                <select className='height35 ml pull-left'>  
                                    <option >Track/Release</option>
                                    <option >Track</option>
                                </select>

                                <button className='icon-btn info width120 height35 pull-left'>All Time</button>
                                <button className='icon-btn info width120 height35 pull-left'>Period</button>

                                <button className='icon-btn info width120 height35 pull-right'>Filter</button>
                            </div>

                        </div>

                        <div className='ws-12'>

                            <div className='w-25 mtl'>
                                <div className='ws-12'>

                                    <span className='text-l text-bold'>DSP Performance</span>

                                    <div className='box ws-12 pm'>
                                        <div className='ws-12'>
                                            <span className='text-bold ws-4'>Top DSPs</span>
                                            <div className='ws-4 pull-right box landing AddBorder'>
                                                <span className={dspPageSize == 10 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetDspPageSize(10)}>10</span>
                                                <span className={dspPageSize == 25 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetDspPageSize(25)}>25</span>
                                                <span className={dspPageSize == 50 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetDspPageSize(50)}>50</span>
                                                <span className={dspPageSize == 100 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetDspPageSize(100)}>100</span>

                                            </div>
                                        </div>
                                        <hr></hr>

                                        <div className='ws-12 allowHscroll allowVscroll'>

                                            {
                                                dsps?.map((dspValues: any) => {
                                                    return (
                                                        <>

                                                            <div className='ws-12 ps'>
                                                                <div className='ws-5 pull-left height60'>
                                                                    <img src={dspValues?.image} height="44" className="fillMaxWidth" />
                                                                    <span className='ws-12'>{dspValues?.name} </span>
                                                                </div>
                                                                <div className='ws-6 pull-right'>
                                                                    <span className='pull-left text-bold'>$ {dspValues?.totalGross}</span>

                                                                    <div className="ws-12 mt height35">
                                                                        <div className="dsp-progress m1 ws-12">
                                                                            <div className="dsp-progress-bar" style={{ width: `${dspValues?.totalGross / 10000000 * 100}%` }} />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>

                                                            <hr />
                                                        </>

                                                    )
                                                })
                                            }
                                        </div>

                                        <span className=' ws-12 text-bold'>Total: $1,592</span>

                                    </div>
                                </div>


                                <div className='ws-12 mtl box pm'>
                                    <div className='ws-12 '>
                                        <span className='text-l text-bold'>Top Imprint</span>
                                        <div className='ws-4 pull-right box landing AddBorder'>
                                            <span className={ImprintPageSize == 10 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetImprintPageSize(10)}>10</span>
                                            <span className={ImprintPageSize == 25 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetImprintPageSize(25)}>25</span>
                                            <span className={ImprintPageSize == 50 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetImprintPageSize(50)}>50</span>
                                            <span className={ImprintPageSize == 100 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetImprintPageSize(100)}>100</span>

                                        </div>
                                    </div>

                                    <div className='ws-12 allowVscroll pLarge pts'>
                                        <VerticalBarChart chartPassedData={imprintRevenue} />
                                    </div>
                                </div>

                            </div>

                            <div className='w-75 pll mtl'>
                                <div className='ws-12'>

                                    <span className='text-l text-bold'>DSP Performance</span>
                                    <div className='box ws-12 pm'>
                                        <AreaChart chartPassedData={yearRevenue} />
                                    </div>
                                </div>

                                <div className='w-49 box pm pull-left mtl'>
                                    <div className='ws-12'>
                                        <span className='text-l text-bold'>Top Territory</span>
                                        <div className='ws-4 pull-right box landing AddBorder'>
                                            <span className={TerritoryPageSize == 10 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetTerritoryPageSize(10)}>10</span>
                                            <span className={TerritoryPageSize == 25 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetTerritoryPageSize(25)}>25</span>
                                            <span className={TerritoryPageSize == 50 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetTerritoryPageSize(50)}>50</span>
                                            <span className={TerritoryPageSize == 100 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetTerritoryPageSize(100)}>100</span>

                                        </div>

                                        <div className='ws-12 allowVscroll pLarge pts'>
                                            <HorizontalBarChart chartPassedData={artistRevenue} />
                                        </div>
                                    </div>
                                </div>

                                <div className='w-49 box pm pull-right mtl'>
                                    <div className='ws-12'>
                                        <span className='text-l text-bold'>Top Artist</span>
                                        <div className='ws-4 pull-right box landing AddBorder'>
                                            <span className={ArtistPageSize == 10 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetArtistPageSize(10)}>10</span>
                                            <span className={ArtistPageSize == 25 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetArtistPageSize(25)}>25</span>
                                            <span className={ArtistPageSize == 50 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetArtistPageSize(50)}>50</span>
                                            <span className={ArtistPageSize == 100 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetArtistPageSize(100)}>100</span>

                                        </div>

                                        <div className='ws-12 allowVscroll pLarge pts'>
                                            <HorizontalBarChart chartPassedData={artistRevenue} />
                                        </div>
                                    </div>
                                </div>

                                <div className='w-49 box pm pull-left mtl'>
                                    <div className='ws-12'>
                                        <span className='text-l text-bold'>Top Assets</span>
                                        <div className='ws-4 pull-right box landing AddBorder'>
                                            <span className={AssetPageSize == 10 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetAssetPageSize(10)}>10</span>
                                            <span className={AssetPageSize == 25 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetAssetPageSize(25)}>25</span>
                                            <span className={AssetPageSize == 50 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetAssetPageSize(50)}>50</span>
                                            <span className={AssetPageSize == 100 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetAssetPageSize(100)}>100</span>

                                        </div>
                                    </div>

                                    <div className='ws-12 allowVscroll pLarge pts'>
                                        <HorizontalBarChart chartPassedData={artistRevenue} />
                                    </div>
                                </div>

                                <div className='w-49 box pm pull-right mtl'>
                                    <div className='ws-12'>
                                        <span className='text-l text-bold'>Top Format</span>
                                        <div className='ws-4 pull-right box landing AddBorder'>
                                            <span className={FormatPageSize == 10 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetFormatPageSize(10)}>10</span>
                                            <span className={FormatPageSize == 25 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetFormatPageSize(25)}>25</span>
                                            <span className={FormatPageSize == 50 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetFormatPageSize(50)}>50</span>
                                            <span className={FormatPageSize == 100 ? 'ws-3 text-bold bg-grey ps text-center' : 'ws-3 ps text-center'} onClick={() => SetFormatPageSize(100)}>100</span>

                                        </div>
                                    </div>

                                    <div className='ws-12 allowVscroll pLarge pts'>
                                        <HorizontalBarChart chartPassedData={artistRevenue} />
                                    </div>
                                </div>


                            </div>

                        </div>




                        <div className="box-footer">
                            <button className="icon-btn delete width100 height35 pull-right" onClick={EmailStatementClose}> Close </button>

                        </div>

                    </div>

                </div>

            </Drawer>

        </>
    )
}